<template>
  <div class="holev-gap">
    <div class="btn-resource-add d-flex justify-end">
      <v-btn
        large
        depressed
        max-height="32px"
        color="#fecd06"
        class="button-type-1"
        @click="appendResource"
      >
        <v-icon left> mdi-plus </v-icon>
        동영상 소재추가
      </v-btn>
    </div>
    <div
      class="resource-cont relative white rounded pa-6 pb-8 pr-16"
      v-for="(resource, i) in this.resources"
      :key="i"
    >
      <!-- resource-box -->
      <div class="resource-box relative">
        <!-- 소재명 -->
        <v-form v-model="valid[i]">
          <div class="form-row-1">
            <p class="label">
              소재명
              <span class="required">
                <v-icon>mdi-check-circle-outline</v-icon>
                필수
              </span>
            </p>
            <div class="write-con">
              <div>
                <v-text-field
                  v-model="resource.name"
                  label="첨부할 영상 소재명을 입력해주세요. (한글/영문 20자이내)"
                  class="input-custom-2"
                  height="40px"
                  solo
                  :rules="subjectTitleRules"
                ></v-text-field>
              </div>
            </div>
          </div>
        </v-form>
        <!-- //소재명 -->
        <!-- 예약설정 -->
        <div class="form-row-1 mb-8">
          <p class="label">
            예약설정
            <span class="required">
              <v-icon>mdi-check-circle-outline</v-icon>
              필수
            </span>
          </p>
          <div class="write-con">
            <div class="datepicker-type-1">
              <v-icon>mdi-calendar-blank</v-icon>
              <date-range-picker
                ref="picker"
                v-model="resource.dateRange"
                :date-format="dateFormat"
                :locale-data="localeData"
                :ranges="false"
                :time-picker="true"
                :time-picker-seconds="true"
                :time-picker-increment="1"
                opens="right"
                @update="updateDateRange(resource)"
              >
                <template v-slot:input="picker" style="min-width: 350px">
                  {{ picker.startDate | moment('YYYY.MM.DD HH:mm:ss') }}
                  <span class="ml-3 mr-3"> ~ </span>
                  {{ picker.endDate | moment('YYYY.MM.DD HH:mm:ss') }}
                </template>
              </date-range-picker>
            </div>
          </div>
        </div>
        <!--// 예약설정 -->
        <!-- 파일업로드 -->
        <div class="form-row-1 mb-8" style="border: 1p solid blue">
          <p class="label">
            파일첨부
            <span class="required">
              <v-icon>mdi-check-circle-outline</v-icon>
              필수
            </span>
          </p>
          <div class="write-con">
            <div class="file-upload-box-2">
              <!-- reource에 파일이 있으면 보이도록 -->
              <div v-if="resource.file">
                <div v-if="!file[i].thumb" class="file-thumb">
                  <video width="84" height="84" controls>
                    <source :src="resource.file" type="video/x-ms-wmv" />
                    <source :src="resource.file" type="video/webm" />
                    <source :src="resource.file" type="video/mp4" />
                  </video>
                </div>
                <div v-else class="file-thumb">
                  <video width="84" height="84" controls>
                    <source :src="file[i].thumb" type="video/x-ms-wmv" />
                    <source :src="file[i].thumb" type="video/webm" />
                    <source :src="file[i].thumb" type="video/mp4" />
                  </video>
                </div>
              </div>
              <!-- reource에 파일이 없고 등록할 때 보이도록 -->
              <div v-else class="file-thumb">
                <div v-if="file[i].thumb">
                  <video width="84" height="84" controls>
                    <source :src="file[i].thumb" type="video/x-ms-wmv" />
                    <source :src="file[i].thumb" type="video/webm" />
                    <source :src="file[i].thumb" type="video/mp4" />
                  </video>
                </div>
                <v-icon v-else>mdi-image-outline</v-icon>
              </div>

              <div class="file-text">
                <div class="file-wrap">
                  <v-btn
                    large
                    depressed
                    max-height="32px"
                    color="#fecd06"
                    class="button-type-1"
                    type="file"
                  >
                    파일 업로드
                  </v-btn>
                  <input
                    type="file"
                    @change="fileSizeCheck($event, i)"
                    accept="video/x-ms-wmv,video/webm,video/mp4"
                    :id="`fileUploader${i}`"
                  />
                </div>
                <p class="form-coment-1 my-1 mt-3">
                  <v-icon>mdi-alert-circle-outline</v-icon>
                  .WMV 영상 길이는 6초이며 1개의 홀당 1개의 영상 또는 이미지만
                  등록이 가능하다. 소재 추가시, 선택한 타입의 소재만 추가 등록
                  가능하다. (용량 100MB이하)
                </p>
                <div v-if="!resource.file">
                  <div v-if="file[i].thumb">
                    <p class="file-name mb-0 mt-1" v-if="file.name">
                      {{ file[i].name }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- //파일업로드 -->
        <!-- 영상해시 -->
        <div class="form-row-1">
          <p class="label">
            영상해시
            <span class="required">
              <v-icon>mdi-check-circle-outline</v-icon>
              필수
            </span>
          </p>
          <div class="write-con">
            <v-text-field
              v-model="resource.hash"
              label="영상별 해시코드를입력해주세요."
              class="input-custom-2"
              height="40px"
              solo
            ></v-text-field>
          </div>
        </div>
        <!-- //영상해시 -->
        <!-- 소재삭제버튼 -->
        <a
          href="javascript:void(0);"
          class="btn-ico-delete"
          @click.stop="openRemoveConfirmPopup(resource, i)"
        >
          <v-icon>mdi-delete</v-icon>
        </a>
        <!--// 소재삭제버튼 -->
        <!-- 소재저장 버튼-->
        <div class="d-flex justify-center">
          <div v-if="!resource.id">
            <v-btn
              large
              depressed
              max-height="32px"
              color="#fecd06"
              class="button-type-1"
              type="button"
              :disabled="!valid[i] || !resource.hash || !file[i].thumb"
              @click.prevent="saveResources(resource)"
            >
              저장
            </v-btn>
          </div>
          <div v-else>
            <v-btn
              large
              depressed
              max-height="32px"
              color="#fecd06"
              class="button-type-1"
              type="button"
              :disabled="!valid[i] || !resource.hash"
              @click="updateResources(resource)"
            >
              수정
            </v-btn>
          </div>
        </div>
        <!-- //소재저장 버튼 -->
      </div>
      <!-- //resource-box -->
    </div>
    <SystemAlert v-model="confirmSystemAlert">
      <div slot="noti-text">{{ logResult }}</div>
      <div slot="noti-btns">
        <v-btn
          large
          depressed
          max-height="40px"
          min-width="104px"
          color="#fecd06"
          class="button-type-1"
          @click.stop="removeResource"
        >
          확인
        </v-btn>
        <v-btn
          large
          depressed
          max-height="40px"
          min-width="104px"
          color="#fff"
          class="button-type-1 ml-2"
          @click.stop="confirmSystemAlert = false"
        >
          취소
        </v-btn>
      </div>
    </SystemAlert>
    <SystemAlert v-model="showSystemAlert">
      <div slot="noti-text" v-html="logResult"></div>
      <div slot="noti-btns">
        <v-btn
          large
          depressed
          max-height="40px"
          min-width="104px"
          color="#fecd06"
          class="button-type-1"
          @click.stop="showSystemAlert = false"
        >
          확인
        </v-btn>
      </div>
    </SystemAlert>
  </div>
</template>

<script>
import bus from '@/utils/bus';
import SystemAlert from '~@/modal/SystemAlert.vue';
import { addResource, updateResource, deleteResource } from '@/api/campaign';
import { uploadImgPermissions, uploadFile, createUploadForm } from '@/api/etc';
import { toISOFormattedDate } from '@/utils/validation';
import DateRangePicker from 'vue2-daterange-picker';

export default {
  components: {
    DateRangePicker,
    SystemAlert,
  },
  props: {
    propsInventoryType: String,
    propsInventoryId: String,
    propsInventory: Object,
    propsLineItemId: String,
    propsLriId: String,
    propsResources: Array,
    propsAdvertiserId: String,
  },

  data: () => ({
    valid: [false],
    subjectTitleRules: [
      v => !!v || '소재명을 입력해주세요.',
      v =>
        (v && /^[ㄱ-ㅎ|가-힣|a-z|A-Z|0-9|_\-\s]+$/.test(v)) ||
        '한글/영문 20자 이내로 입력해주세요.',
      v => (v && v.length <= 20) || '한글/영문 20자 이내로 입력해주세요.',
    ],
    localeData: {
      format: `yyyy-mm-dd HH:MM:ss`,
      applyLabel: '확인',
      cancelLabel: '취소',
      separator: '　~　',
    },

    file: {
      img: null,
      name: null,
      thumb: null,
      type: 0,
    },

    fileCnt: 1,
    fileCategory: 'video',
    permissionInfo: {},
    preFilePath: '',

    defaultResource: {
      dateRange: { startDate: null, endDate: null },
      name: '',
      start_at: null,
      end_at: null,
      is_valid: 'Y',
      type: 0,
      hash: '',
      file: '',
    },
    showSystemAlert: false,
    confirmSystemAlert: false,
    logResult: '',
    editItem: '',
    editItemIndex: null,
  }),
  computed: {
    resources: {
      get() {
        let arr = [];
        if (this.propsResources.length > 0) {
          this.propsResources.map(resource => {
            if (resource.type === 0) {
              let obj = {
                startDate: resource.start_at,
                endDate: resource.end_at,
              };
              resource.dateRange = obj;
              arr.push(resource);
            }
          });
        }
        return arr;
      },
      set(value) {
        this.propsResources = value;
      },
    },
    defaultStartAt() {
      return this.propsInventory.start_at;
    },
    defaultEndAt() {
      return this.propsInventory.end_at;
    },
  },
  methods: {
    dateFormat(classes, date) {
      if (!classes.disabled) {
        if (date < this.$moment(this.propsInventory.start_at)) {
          classes.disabled = true;
        }
        if (date > this.$moment(this.propsInventory.end_at)) {
          classes.disabled = true;
        }
      }
      return classes;
    },
    fileSizeCheck(e, i) {
      const targetFile = e.target.files[0];
      console.log('targetFile', targetFile);
      if (targetFile.size <= 104857600) {
        this.onFileChange(e, i);
      } else {
        this.showSystemAlert = true;
        this.logResult = '가이드에 맞지 않는 용량, 해상도 입니다.';
      }
    },
    onFileChange(e, i) {
      const targetFile = e.target.files[0];

      if (
        targetFile.type === 'video/x-ms-wmv' ||
        targetFile.type === 'video/webm' ||
        targetFile.type === 'video/mp4'
      ) {
        this.file[i].name = targetFile.name;
        this.file[i].thumb = URL.createObjectURL(targetFile);
        this.file[i].img = targetFile;
        this.file[i].type = 1;
        this.fileCategory =
          targetFile.type === 'video/x-ms-wmv'
            ? 'wmv'
            : targetFile.type === 'video/webm'
            ? 'webm'
            : 'mp4';

        this.permissionsImg(i);
      } else {
        this.showSystemAlert = true;
        this.logResult = 'WMV, WEBM, MP4 형식만 사용 가능 합니다.';
      }
      document.getElementById(`fileUploader${i}`).value = '';
    },
    async permissionsImg(i) {
      try {
        const params = {
          cnt: this.fileCnt,
          category: this.fileCategory,
        };
        const { data } = await uploadImgPermissions({ params });
        this.permissionInfo = data.list[0];
        await this.savefileUpload(i);
      } catch (error) {
        console.log(error.response);
      }
    },
    savefileUpload(i) {
      let url = this.permissionInfo.domain;
      this.preFilePath = this.permissionInfo.uploadImagePath;
      const formData = createUploadForm(this.permissionInfo, this.file[i].img);

      this.uploadComplete(url, formData);
    },
    async uploadComplete(url, formData) {
      try {
        await uploadFile(url, formData);
        this.$forceUpdate();
      } catch (error) {
        console.log(error.response);
      }
    },

    setDetailResourceIfEmpty() {
      if (this.propsResources.length === 0) {
        this.defaultResource.dateRange.startDate = this.defaultStartAt;
        this.defaultResource.dateRange.endDate = this.defaultEndAt;
        this.defaultResource.start_at = this.defaultStartAt;
        this.defaultResource.end_at = this.defaultEndAt;
        this.propsResources.push(
          JSON.parse(JSON.stringify(this.defaultResource)),
        );
      }
    },

    async saveResources(resource) {
      //bus.$emit('start:spinner');
      if (!this.propsLriId) {
        this.showSystemAlert = true;
        this.logResult = '홀을 선택해주세요.';
      } else {
        //await this.savefileUpload(i);

        const campaignId = this.$route.params.id;
        const inventoryId = this.propsInventoryId;
        const lineItemId = this.propsLineItemId;
        const lriId = this.propsLriId;

        resource.name = resource.name.trim();
        resource.start_at = toISOFormattedDate(new Date(resource.start_at));
        resource.end_at = toISOFormattedDate(new Date(resource.end_at));
        resource.file = this.preFilePath;

        try {
          const { data } = await addResource(
            campaignId,
            inventoryId,
            lineItemId,
            lriId,
            resource,
          );
          if (data.result === 'success') {
            const emitData = {
              resourceId: data.value,
              lriId: this.propsLriId,
              resourceType: 0,
            };
            this.$emit('getResourceAfterAdd', emitData);
            this.logResult = '저장되었습니다.';
            this.showSystemAlert = true;
          }
        } catch (error) {
          const { data } = error.response;
          if (data.result === 'OutRange') {
            this.showSystemAlert = true;
            this.logResult =
              '소재의 시작/종료는 지면의 시작, 종료일 범위 내에서만 설정 가능합니다.';
          } else if (data.result === 'IsAlreadyReserved') {
            this.showSystemAlert = true;
            this.logResult = '선택된 지면은 현재 집행중인 캠페인이 있습니다.';
          } else {
            console.log(error.response);
          }
        }
      }
    },

    async updateResources(resource) {
      const campaignId = this.$route.params.id;
      const inventoryId = this.propsInventoryId;
      const lineItemId = this.propsLineItemId;
      const lriId = this.propsLriId;
      const resourceId = resource.id;

      let updateResourceFile = '';
      if (this.preFilePath && resource.file !== this.preFilePath) {
        updateResourceFile = this.preFilePath;
      } else {
        updateResourceFile = resource.file;
      }

      const resourceData = {
        type: 0,
        name: resource.name.trim(),
        start_at: toISOFormattedDate(new Date(resource.start_at)),
        end_at: toISOFormattedDate(new Date(resource.end_at)),
        file: updateResourceFile,
        hash: resource.hash,
      };

      try {
        const { data } = await updateResource(
          campaignId,
          inventoryId,
          lineItemId,
          lriId,
          resourceId,
          resourceData,
        );

        if (data.result === 'success') {
          const emitData = {
            resourceId: resourceId,
            lriId: this.propsLriId,
            resourceType: 0,
          };
          this.$emit('getResourceAfterAdd', emitData);
          this.logResult = '수정되었습니다.';
          this.showSystemAlert = true;
        }
      } catch (error) {
        console.log(error.response);
        const { data } = error.response;
        if (data.result === 'OutRange') {
          this.showSystemAlert = true;
          this.logResult =
            '소재의 시작/종료는 지면의 시작, 종료일 범위 내에서만 설정 가능합니다.';
        }
      }
    },

    updateDateRange(resource) {
      resource.start_at = resource.dateRange.startDate;
      resource.end_at = resource.dateRange.endDate;
    },

    openRemoveConfirmPopup(item, i) {
      if (!item.id) {
        if (this.propsResources.length > 1) {
          this.propsResources.splice(i, 1);
          this.valid.splice(i, 1);
        } else {
          return false;
        }
      } else {
        this.editItem = item;
        this.editItemIndex = i;
        this.logResult = '정말로 삭제하시겠습니까?';
        this.confirmSystemAlert = true;
      }
    },
    async removeResource() {
      bus.$emit('start:spinner');
      this.confirmSystemAlert = false;
      try {
        const campaignId = this.$route.params.id;
        const inventoryId = this.propsInventoryId;
        const lineItemId = this.propsLineItemId;
        const lriId = this.propsLriId;
        const resourceId = this.editItem.id;
        const { data } = await deleteResource(
          campaignId,
          inventoryId,
          lineItemId,
          lriId,
          resourceId,
        );
        if (data.result === 'success') {
          //validation check 순번 삭제
          this.valid.splice(this.editItemIndex, 1);

          //this.file.splice(this.editItemIndex, 1);
          this.file[this.editItemIndex].name = null;
          this.file[this.editItemIndex].thumb = null;
          this.file[this.editItemIndex].img = null;
          this.file[this.editItemIndex].type = 1;
          this.logResult = '삭제되었습니다.';
          this.showSystemAlert = true;
          const emitData = {
            resourceId: resourceId,
            lriId: this.propsLriId,
            resourceType: 0,
          };
          this.$emit('getResourceAfterDelete', emitData);
        }
        bus.$emit('end:spinner');
      } catch (error) {
        bus.$emit('end:spinner');
        console.log(error.response);
      }
    },
    appendResource() {
      //validate check 추가
      this.valid.push(false);

      this.file.push({
        img: null,
        name: null,
        thumb: null,
        type: 1,
      });

      this.defaultResource.dateRange.startDate = this.defaultStartAt;
      this.defaultResource.dateRange.endDate = this.defaultEndAt;
      this.defaultResource.start_at = this.defaultStartAt;
      this.defaultResource.end_at = this.defaultEndAt;
      this.propsResources.push(
        JSON.parse(JSON.stringify(this.defaultResource)),
      );
    },
  },
  created() {
    this.setDetailResourceIfEmpty();
    if (this.file.length !== this.resources.length) {
      this.file = [];
      for (let i = 0; i < this.resources.length; i++) {
        this.file.push({
          img: null,
          name: null,
          thumb: null,
          type: 1,
        });
      }
    }
  },
  mounted() {},
  beforeUpdate() {
    if (this.file.length !== this.resources.length) {
      this.file = [];
      for (let i = 0; i < this.resources.length; i++) {
        this.file.push({
          img: null,
          name: null,
          thumb: null,
          type: 1,
        });
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.holev-gap {
  .resource-cont {
    padding-left: 118px !important;
    padding-right: 0px !important;
    padding-top: 0px !important;
  }
  .btn-resource-add {
    position: absolute;
    top: 24px;
    right: 64px;
  }
}
</style>
